import shortSoundUrl from "assets/sounds/Short.mp3";
import longSoundUrl from "assets/sounds/Long.mp3";

let shortAudio: HTMLAudioElement | null = null;
let longAudio: HTMLAudioElement | null = null;

export const playMilestoneSound = () => {
  if (typeof window === "undefined") return;
  shortAudio ??= new Audio(shortSoundUrl);
  shortAudio.currentTime = 0;
  shortAudio.play().catch(() => { /* browser autoplay policy */ });
};

export const playFanfareSound = () => {
  if (typeof window === "undefined") return;
  longAudio ??= new Audio(longSoundUrl);
  longAudio.currentTime = 0;
  longAudio.play().catch(() => { /* browser autoplay policy */ });
};
